import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  // A bootstrap failure is an error, not a note: console.error is what a browser surfaces by
  // default and what a crash reporter picks up.
  .catch(err => console.error(err));
